import request from "@/utils/request";

//获取轮播列表
export function getImages() {
  return request({
    url: "/images",
    method: "get"
  });
}

//获取历史首页介绍图列表
export function getIntroduceImages(){
  return request({
    url: "/images/introduce",
    method: "get",
  });
}

//获取所有历史企业自评图列表
export function getEvaluateImages(){
  return request({
    url: "/images/evaluate",
    method: "get",
  });
}

//获取所有历史产业地图图列表
export function getIndustryImages(){
  return request({
    url: "/images/industry",
    method: "get",
  });
}